import {
  Root as ScrollAreaRoot,
  ScrollAreaViewport,
  ScrollAreaScrollbar,
  ScrollAreaThumb,
  ScrollAreaCorner,
} from '@radix-ui/react-scroll-area'
import { CSSProperties, FunctionComponent, ReactNode } from 'react'
import styled from 'styled-components'

interface ScrollAreaProps {
  children: ReactNode
  className?: string
  style?: CSSProperties
}
const ScrollArea: FunctionComponent<ScrollAreaProps> = ({
  children,
  ...props
}) => (
  <StyledRoot {...props}>
    <StyledViewport>{children}</StyledViewport>
    <StyledScrollbar orientation='vertical'>
      <StyledThumb />
    </StyledScrollbar>
    <StyledScrollbar orientation='horizontal'>
      <StyledThumb />
    </StyledScrollbar>
    <StyledCorner />
  </StyledRoot>
)

const StyledRoot = styled(ScrollAreaRoot)`
  width: 100%;
  height: 100%;
  overflow: hidden;
`

const StyledViewport = styled(ScrollAreaViewport)`
  width: 100%;
  height: 100%;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */

  &::-webkit-scrollbar {
    display: none; /* Chrome/Safari/Webkit */
  }

  > div {
    display: block !important;
  }
`

const StyledScrollbar = styled(ScrollAreaScrollbar)`
  display: flex;
  user-select: none;
  touch-action: none;
  padding: 3px;
  background-color: #f1f1f1;

  &[data-orientation='vertical'] {
    width: 12px;
  }

  &[data-orientation='horizontal'] {
    height: 12px;
    flex-direction: column;
  }
`

const StyledThumb = styled(ScrollAreaThumb)`
  flex: 1;
  background-color: #c1c1c1;
  border-radius: 4px;
  position: relative;
  transition: background-color 160ms ease-out;

  &:hover {
    background-color: #7d7d7d;
  }

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
  }
`

const StyledCorner = styled(ScrollAreaCorner)``

export default ScrollArea
